import { PARACHAIN_BONDING_PATH } from '../../common/const';

export const ASSETS_PATH = PARACHAIN_BONDING_PATH;
